import { render, staticRenderFns } from "./createUpdateUserView.vue?vue&type=template&id=d20ef550&scoped=true&"
import script from "./createUpdateUserView.vue?vue&type=script&lang=js&"
export * from "./createUpdateUserView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20ef550",
  null
  
)

export default component.exports